import { Controller } from 'stimulus';

export default class extends Controller {
  update() {
    document.querySelector(`[data-controller="shared--filters"] input[name="${this.element.name}"]`).value = this.element.value;
    document.querySelector('[data-controller="shared--filters"]').submit();
  }
}
